import { render, staticRenderFns } from "./ListAddress.vue?vue&type=template&id=8d64335a&scoped=true"
import script from "./ListAddress.vue?vue&type=script&lang=js"
export * from "./ListAddress.vue?vue&type=script&lang=js"
import style0 from "./ListAddress.vue?vue&type=style&index=0&id=8d64335a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d64335a",
  null
  
)

export default component.exports